import { UsersApi } from '@sportheroes/oly-engine-api';

import { olyEngineApi } from './Config/olyEngineApi';
import { getDeviceId, getDeviceName } from './Config/utils';

const { USERS_API_URL } = process.env;

export default new UsersApi(
  USERS_API_URL,
  { fromAdmin: true, deviceId: getDeviceId(), deviceName: getDeviceName() },
  olyEngineApi,
);
